import React from 'react';

import { Button, Link, UIText2 } from '@cian/ui-kit';
import { ETestIds } from '../../constants';
import { useAuthAction } from '../../hooks/useAuthAction';
import { useTracking } from '../../utils/tracking/useTracking';

import * as styles from './styles.css';
import { NBSP } from 'shared/common/constants';
import { selectNewbuildingSeoLinkUrl } from 'shared/mortgageMiniCalculator/selectors/calculator';
import { useSelector } from 'react-redux';
import clsx from 'clsx';

export const ActionsContainer: React.FC = () => {
  const { trackClickOnTargetButton } = useTracking();
  const { isLoading, handleAuthAction } = useAuthAction({
    trackingFunction: trackClickOnTargetButton,
  });

  const seoUrl = useSelector(selectNewbuildingSeoLinkUrl);

  return (
    <div className={clsx(styles['btn'], seoUrl && styles['btn--spaced'])}>
      {seoUrl && (
        <Link href={seoUrl} target="_blank" fontSize="S" inline data-testid="newbuilding-mortgage-link">
          Ипотечные предложения и аккредитованные банки
        </Link>
      )}
      <div className={styles['wrapper']}>
        <Button
          size="M"
          onClick={handleAuthAction}
          loading={isLoading}
          disabled={isLoading}
          data-testid={ETestIds.MainButton}
        >
          Заполнить заявку на Циане
        </Button>
        <div>
          <UIText2
            textAlign="right"
            color={'text-secondary-default'}
          >{`Заявка${NBSP}— единая для всех банков.`}</UIText2>
          <UIText2
            textAlign="right"
            color={'text-secondary-default'}
          >{`Перед${NBSP}заполнением попросим авторизоваться.`}</UIText2>
        </div>
      </div>
    </div>
  );
};
